<template>

    <form class="dropzone digits" id="singleFileUpload">
		<div class="dz-message needsclick">
			<i class="icon-cloud-up"></i>
			<h6>{{ instanceOptions.dictDefaultMessage }}</h6>


            <template v-if="instanceOptions.acceptedFiles != null">
                <br />
                <span style="font-style: italic;">Supports : {{ instanceOptions.acceptedFiles }}</span>
            </template>
		</div>
	</form>

</template>

<script>
export default {
    data : function () {
        return {
            id : null,
            dropzoneElement : null,
            instanceOptions: {
                dictDefaultMessage: "Glissez un fichier ici",
                dictFallbackMessage: "Votre navigateur n'est pas compatible avec le glisser déposer.",
                dictFileTooBig: "Fichier trop volumineux : ({{filesize}}Mo). Max : {{maxFilesize}}Mo.",
                dictInvalidFileType: "Type de fichier interdit.",
                dictResponseError: "Erreur serveur : {{statusCode}}.",
                dictCancelUpload: "Annuler",
                dictCancelUploadConfirmation: "Vous-vous vraiment annuler ?",
                dictRemoveFile: "Supprimer ce fichier",
                dictMaxFilesExceeded: "Vous ne pouvez pas envoyer d'autres fichiers",
                acceptedFiles : null,
                thumbnailWidth: 150,
                maxFilesize: 5,
                maxFiles: 1,
                method : 'post',
                headers: { 'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content') },
                error: (file, response) => {

                    // intercept picture dimensions issue
                    if (response.data != undefined && response.data.thumbnail != undefined && response.data.thumbnail == "validation.dimensions")
                    {
                        this.$httpError({ error: "L'image n'est pas aux bonnes dimensions." });
                        this.$emit('error');
                    }
                    else
                    {
                        this.$httpError({ error: response });
                        this.$emit('error');
                    }
                },
                success: (file, response) => {
                    this.$emit('success', response);
                },
                queuecomplete: (totalPercentage, totalBytesToBeSent, totalBytesSent) => {
                    this.$emit('queuesuccess');
                },
            },
        }
    },
    props: {
        options : { type : Object, required : true}
    },
    mounted : function() {
        this.instanceOptions = {
            ...this.instanceOptions,
            ...this.options
        }
        this.dropzoneElement = new Dropzone(this.$el, this.instanceOptions);
    },
    methods : {
        submit : function() {
            this.dropzoneElement.processQueue();
        }
    }
}
</script>

<style scoped>
.dropzone {
    background-color: #f8f9fe;
    border-color: #707070 !important;
}

h6,i {
    color:#3c3739 !important;
}

.dropzone.dz-clickable .dz-message * {
    cursor: pointer;
}
</style>
